<template>
  <div id="image_preloader" ref="root">
    <div class="spinner-wrapper">
      <div v-show="showSpinner" id="preloader-spinner"></div>
    </div>
    <img class="preloader-render-image" v-show="showImage" :src="imageSrc" alt="Some large image" ref="image">
  </div>
</template>

<script>
export default {
  name: 'ImagePreloader',
  props: ['callback', 'testProp', 'image_url'],
  data () {
    return {
      msg: 'Image Preloader',
      imageSrc: '',
      showSpinner: false,
      showImage: false
    }
  },
  methods: {
    atLoad () {
      alert('Loaded')
    },
    fetchImage (fetchUrl) {
      this.showSpinner = true
      this.showImage = false
      this.$http.get(fetchUrl, {
        responseType: 'arraybuffer',
        headers: {
          'Accept': 'image'
        }
      })
        .then((response) => {
          let u8 = new Uint8Array(response.data)
          let blob = new Blob([u8])
          let urlCreator = window.URL || window.webkitURL
          let imageSrc = urlCreator.createObjectURL(blob)
          // let image = document.createElement('img')
          let image = this.$refs.image
          // image.classList.add('preloader-render-image')
          image.onload = (event) => {
            console.log(image.complete)
            this.$refs.root.appendChild(image)
            console.log('IMAGE IS LOADED', 'testProp: ' + this.testProp)
            // let style = window.getComputedStyle(image)
            // let height = style.getPropertyValue('height')
            // let width = style.getPropertyValue('width')
            // console.log(style)
            // console.log(height)
            // console.log(width)
            if (typeof this.callback === 'function') {
              this.callback()
            }
            this.showSpinner = false
            this.showImage = true
          }
          this.imageSrc = imageSrc
        })
        .catch((error) => {
          console.error(error)
        })
    }
  },
  mounted () {
    this.fetchImage(this.image_url)
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#image_preloader{
  height: 100%;
  width: 100%;
  max-height: 100%;
  background-color: cyan;
  display: flex;
  justify-content: center;
  align-items: center;

}
#image_preloader .preloader-render-image {
  width: 100%;
  height: 100%;
  max-width: 20vw;
  max-height: 30vh;
  /* max-width: 15%; */
}
#image_preloader #preloader-spinner {
  border: 16px solid #f3f3f3;
  border-radius: 50%;
  border-top: 16px solid #3498db;
  width: 30px;
  height: 30px;
  -webkit-animation: spin 1s linear infinite; /* Safari */
  animation: spin 1s linear infinite;
}

/* Safari */
@-webkit-keyframes spin {
  0% { -webkit-transform: rotate(0deg); }
  100% { -webkit-transform: rotate(360deg); }
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>



// WEBPACK FOOTER //
// src/components/ImagePreloader.vue